module.exports = "../study/imgs/maps/Kanagawa/S8/Climate/Temperture/Kanagawa_Temperture_HadGEM2_RCP26_End.png";